<template>
  <page-outline :title="$t('administration.company_edit')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="pb-3 no-gutters">
          <back-button class="btnFilter_2" :returnUrl="returnUrl"></back-button>
        </b-row>
        <br>
        <hr class="mx-auto" />
        <br>
        <spinner v-if="activateSpinner"></spinner>
        <form-accordion v-if="activateSpinner === false" :isTitleUpperCase="false" :title="$t('common.busnss')">
          <b-row class = 'ml-2 mr-2'>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="identifier" isMandatory
                :inputLabel="$t('administration.company_id')" :placeholderValue="CompaniesList[0].identifier">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="name" isMandatory
                :inputLabel="$t('administration.name')" :placeholderValue="CompaniesList[0].name">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class = 'ml-2 mr-2'>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input isMandatory
                :inputType="'listeSelect'" :inputLabel="$t('administration.active_enable')" :placeholderValue="CompaniesList[0].active">
                <select class="form-control" id="sel4" v-model="active">
                  <option value="0"> {{ $t('administration.no') }} </option>
                  <option value="1"> {{ $t('administration.in_prgrss') }} </option>
                  <option value="2"> {{ $t('administration.yes') }} </option>
                </select>
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="email_reference"
                :inputLabel="$t('administration.company_email')" :placeholderValue="CompaniesList[0].email_reference">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class = 'ml-2 mr-2'>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="address" isMandatory
                :inputLabel="$t('administration.address')" :placeholderValue="$t('administration.address')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="city" isMandatory
                :inputLabel="$t('administration.city')" :placeholderValue="$t('administration.city')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="zip_code" isMandatory
                :inputLabel="$t('administration.zip_code')" :placeholderValue="$t('administration.zip_code')">
              </form-write-group-label-input>
           </b-col>
            <b-col sm="6" class="form-group">
             <form-write-group-label-input isMandatory :inputType="'listeSelect'"
                :inputLabel="$t('administration.country')">
                <select class="form-control" v-model="country">
                  <option v-for="opt in countryOptions" :key="opt.iso2" :value="opt.iso2">
                    {{ $t('countries.' + opt.key) }}
                  </option>
                </select>
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class="justify-content-end form-group no-gutters mt-2" v-if="canCompanyEdit">
            <b-button class="btnFilter_2"
              @click="changeCompany()">
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.sve') }}</span>
            </b-button>
          </b-row>
        </form-accordion>
        <br>
        <hr class="mx-auto" />
        <br>
        <form-accordion v-if="activateSpinner === false" :isTitleUpperCase="false" :title="$t('administration.company_users')">
          <b-table v-if="CompaniesList[0].users > 0" hover
            :fields="userFields"
            :items="CompaniesList[0].users"
            :selectable="CompaniesList[0].users.length > 0"
            :sort-by.sync="sortBy"
            empty-text="Pas de résultat"
            @row-selected="seeUserDetails">
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="activateUserEdit($event, data.value)"><i class="fa-light fa-pencil"></i></span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="activateUserDelete($event, data.value)"><i class="fa-light fa-trash"></i></span>
              </template>
          </b-table>
          <b-row v-else class="justify-content-center">
            {{ $t('common.no_usercompany') }}
          </b-row>
          <b-row class="justify-content-end no-gutters" v-if="canUserAdd">
            <b-button class="btnFilter_2"
              @click="addUser">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('administration.user_add')}}</span>
            </b-button>
          </b-row>
        </form-accordion>
        <br>
        <hr class="mx-auto" />
        <br>
        <form-accordion v-if="activateSpinner === false" :isTitleUpperCase="false" :title="$t('administration.company_prfls')">
          <b-table v-if="CompaniesList.length > 0" hover
            :fields="profileFields"
            :items="CompaniesList[0].profiles"
            :selectable="CompaniesList[0].profiles.length > 0"
            :key="resetProfileTable"
            empty-text="Pas de résultat"
            @row-selected="seeProfileDetails">
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="activateProfilEdit($event, data.value)"><i class="fa-light fa-pencil"></i></span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="activateProfilDelete($event, data.value)"><i class="fa-light fa-trash"></i></span>
              </template>
          </b-table>
          <b-row class="justify-content-end no-gutters" v-if="canAddProfil">
            <b-button class="btnFilter_2"
            @click="addProfil">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('administration.profile_add')}}</span>
            </b-button>
          </b-row>
        </form-accordion>
        <br>
        <hr class="mx-auto" />
        <br>
        <form-accordion v-if="activateSpinner === false" :isTitleUpperCase="false" :title="$t('administration.company_rights')">
          <b-table v-if="CompaniesList.length > 0"
            :items="rights"
            :fields="rightsFields"
            :key="resetProfileTable">
            <template #cell(right)="data">
            <span>{{ $t('rights.db_rights.' + data.value) }}</span>
            </template>
            <template #cell(delete)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="deleteRight($event, data.value)"><i class="fa-light fa-trash"></i></span>
            </template>
          </b-table>
          <b-row class="justify-content-end no-gutters" v-if="false">
            <b-button variant="primary"
            @click="addRight">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('administration.right_add')}}</span>
            </b-button>
          </b-row>
        </form-accordion>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'

import {loadPage} from '@/helpers/routing'
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'EditUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner
  },
  props: ['idCompany'],
  computed: {
    canAddProfil () {
      return this.$engine.rights.rightIs('profilcompany_ajouter', true)
    },
    canAddRights () {
      return this.$engine.rights.rightIs('company_editer', true)
    },
    canCompanyEdit () {
      return this.$engine.rights.rightIs('company_editer', true)
    },
    canDeleteRight () {
      return this.$engine.rights.rightIs('company_editer', true)
    },
    canProfileConsult () {
      return this.$engine.rights.rightIs('profilcompany_consulter', true)
    },
    canProfileEdit () {
      return this.$engine.rights.rightIs('profilcompany_editer', true)
    },
    canProfileDelete () {
      return this.$engine.rights.rightIs('profilcompany_supprimer', true)
    },
    canUserAdd () {
      return this.$engine.rights.rightIs('usercompany_ajouter', true) || this.$engine.rights.rightIs('usercompany_ajouter_admin', true)
    },
    canUserConsult () {
      return this.$engine.rights.rightIs('usercompany_consulter', true) || this.$engine.rights.rightIs('usercompany_consulter_admin', true)
    },
    canUserEdit () {
      return this.$engine.rights.rightIs('usercompany_editer', true) || this.$engine.rights.rightIs('usercompany_editer_admin', true)
    },
    canUserDelete () {
      return this.$engine.rights.rightIs('usercompany_supprimer', true) || this.$engine.rights.rightIs('usercompany_supprimer_admin', true)
    }
  },
  data () {
    return {
      acc: {},
      activateSpinner: false,
      active: '',
      address: '',
      city: '',
      CompaniesList: [],
      country: '',
      email_reference: '',
      identifier: '',
      name: '',
      profileFields: [],
      redirection: this.$engine.company.redirection,
      resetProfileTable: false,
      returnUrl: '/company/',
      rights: [],
      rightsFields: [],
      sortBy: 'login',
      userFields: [],
      zip_code: '',
      cdtr_scheme_id: '',
      countryOptions: [
        { iso2: 'FR', key: 'france' },
        { iso2: 'DE', key: 'allemagne' },
        { iso2: 'IT', key: 'italie' },
        { iso2: 'ES', key: 'espagne' },
        { iso2: 'BE', key: 'belgique' },
        { iso2: 'LU', key: 'luxembourg' },
        { iso2: 'NL', key: 'pays_bas' },
        { iso2: 'PT', key: 'portugal' },
        { iso2: 'IE', key: 'irlande' },
        { iso2: 'AT', key: 'autriche' },
        { iso2: 'FI', key: 'finlande' },
        { iso2: 'SE', key: 'suede' },
        { iso2: 'DK', key: 'danemark' },
        { iso2: 'NO', key: 'norvege' },
        { iso2: 'IS', key: 'islande' },
        { iso2: 'CH', key: 'suisse' },
        { iso2: 'PL', key: 'pologne' },
        { iso2: 'CZ', key: 'republique_tcheque' },
        { iso2: 'SK', key: 'slovaquie' },
        { iso2: 'SI', key: 'slovenie' },
        { iso2: 'HR', key: 'croatie' },
        { iso2: 'EE', key: 'estonie' },
        { iso2: 'LV', key: 'lettonie' },
        { iso2: 'LT', key: 'lituanie' },
        { iso2: 'MT', key: 'malte' },
        { iso2: 'CY', key: 'chypre' },
        { iso2: 'RO', key: 'roumanie' },
        { iso2: 'BG', key: 'bulgarie' },
        { iso2: 'HU', key: 'hongrie' },
        { iso2: 'GR', key: 'grece' }
      ],
    }
  },
  created () {
    this.$e
    this.returnUrl = this.returnUrl + this.redirection
    this.profileFields = [
      {key: 'libelle', label: this.$t('administration.label'), class:'text-center', tdClass: 'py-3'}
    ]
    this.rightsFields = [
      {key: 'right', label: this.$t('administration.right_list'), class:'text-center', tdClass: 'py-3'}
    ]
    this.userFields = [
      {key: 'login', label: this.$t('administration.login'), class:'text-center', tdClass: 'py-3'}
    ]
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Modification de l\'entreprise',
      returnUrl: ''
    })
    this.$engine.settings.set({msgDirection: this.direction})
    // this.$bus.$off('refresh-cache-contacts')
    this.atStart(this.idCompany) // modif a check
    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    // this.atStart(false)

    this.filterTypeGet = this.filterType
    if(this.canProfileDelete) {
      this.profileFields.push({ key: 'delete', label: this.$t('common.del_label'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    if(this.canProfileEdit) {
      this.profileFields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    if(this.canDeleteRight) {
      // this.rightsFields.push({ key: 'delete', label: this.$t('common.del_label'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    if(this.canUserDelete) {
      this.userFields.push({ key: 'delete', label: this.$t('common.del_label'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    if(this.canUserEdit) {
      this.userFields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
    }
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    normalizeNationalId (cc, raw) {
  if (!raw) return { nid: '', note: '' }

  let nid = String(raw).replace(/\s+/g, '')
  let note = ''

  // Détection ICS existant
  const maybeIcs = String(raw).trim().toUpperCase()
  if (/^[A-Z]{2}\d{2}[A-Z0-9]{3}\d{15}$/.test(maybeIcs)) {
    const last15 = maybeIcs.slice(-15)
    return { nid: last15.slice(-9), note: 'ICS détecté, extraction depuis les 15 digits' }
  }

  if (cc === 'FR') {
    const digits = nid.replace(/\D/g, '')
    if (/^\d{14}$/.test(digits)) {
      nid = digits.slice(0, 9)
      return { nid, note: `SIRET détecté, SIREN utilisé: ${nid}` }
    }
    if (/^\d{9}$/.test(digits)) {
      return { nid: digits, note: `SIREN utilisé: ${digits}` }
    }
    nid = nid.toUpperCase()
    if (/[^A-Z0-9]/.test(nid)) return { nid: '', note: 'Identifiant FR invalide' }
    return { nid, note: 'Identifiant FR non standard' }
  }

  if (cc === 'BE') {
    // Belgique (BCE format 0xxx.xxx.xxx on retire les points)
    const digits = nid.replace(/\D/g, '')
    if (/^\d{10}$/.test(digits)) {
      return { nid: digits, note: `BCE utilisé: ${digits}` }
    }
    return { nid: '', note: 'Identifiant BE invalide - BCE attendu (10 chiffres)' }
  }

  if (cc === 'CH') {
    // Suisse (IDE/UID format CHE-xxx.xxx.xxx on retire CHE- et les points)
    const cleaned = nid.replace(/^CHE[-.]?/i, '').replace(/\D/g, '')
    if (/^\d{9}$/.test(cleaned)) {
      return { nid: cleaned, note: `IDE/UID CH utilisé: ${cleaned}` }
    }
    return { nid: '', note: 'Identifiant CH invalide - IDE/UID attendu (9 chiffres)' }
  }

  if (cc === 'DE') {
    // Allemagne (Steuernummer ou Handelsregisternummer on garde alphanumérique)
    nid = nid.replace(/[\s\-./]/g, '').toUpperCase()
    if (/^[A-Z0-9]{5,15}$/.test(nid)) {
      return { nid, note: `Identifiant DE utilisé: ${nid}` }
    }
    return { nid: '', note: 'Identifiant DE invalide' }
  }

  if (cc === 'IT') {
    // Italie (Codice Fiscale (16 alphanum) ou P.IVA (11 chiffres))
    const digits = nid.replace(/\D/g, '')
    if (/^\d{11}$/.test(digits)) {
      return { nid: digits, note: `P.IVA IT utilisé: ${digits}` }
    }
    nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, '')
    if (/^[A-Z0-9]{16}$/.test(nid)) {
      return { nid, note: `Codice Fiscale IT utilisé: ${nid}` }
    }
    return { nid: '', note: 'Identifiant IT invalide' }
  }

  if (cc === 'ES') {
    // Espagne (NIF/CIF format X12345678 alphanumérique 9 chars)
    nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, '')
    if (/^[A-Z0-9]{9}$/.test(nid)) {
      return { nid, note: `NIF/CIF ES utilisé: ${nid}` }
    }
    return { nid: '', note: 'Identifiant ES invalide' }
  }

  if (cc === 'NL') {
    // Pays-Bas (KvK 8 chiffres ou BTW-id 12 chars)
    const digits = nid.replace(/\D/g, '')
    if (/^\d{8}$/.test(digits)) {
      return { nid: digits, note: `KvK NL utilisé: ${digits}` }
    }
    nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, '')
    if (/^[A-Z0-9]{12}$/.test(nid)) {
      return { nid, note: `BTW-id NL utilisé: ${nid}` }
    }
    return { nid: '', note: 'Identifiant NL invalide' }
  }

  if (cc === 'PT') {
    // Portugal (NIPC 9 chiffres)
    const digits = nid.replace(/\D/g, '')
    if (/^\d{9}$/.test(digits)) {
      return { nid: digits, note: `NIPC PT utilisé: ${digits}` }
    }
    return { nid: '', note: 'Identifiant PT invalide' }
  }

  if (cc === 'AT') {
    // Autriche (Firmenbuchnummer format FN123456a alphanumérique)
    nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, '')
    if (/^[A-Z0-9]{5,12}$/.test(nid)) {
      return { nid, note: `Identifiant AT utilisé: ${nid}` }
    }
    return { nid: '', note: 'Identifiant AT invalide' }
  }

  if (cc === 'PL') {
    // Pologne (NIP 10 chiffres)
    const digits = nid.replace(/\D/g, '')
    if (/^\d{10}$/.test(digits)) {
      return { nid: digits, note: `NIP PL utilisé: ${digits}` }
    }
    return { nid: '', note: 'Identifiant PL invalide' }
  }

  if (cc === 'LU') {
  // Luxembourg (numéro RCS format B123456 alphanumérique)
  nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, '')
  if (/^[A-Z]{1,2}\d{3,6}$/.test(nid)) {
    return { nid, note: `RCS LU utilisé: ${nid}` }
  }
  return { nid: '', note: 'Identifiant LU invalide - RCS attendu (ex: B123456)' }
}

if (cc === 'IE') {
  // Irlande (CRO format 123456 ou IE1234567A on garde alphanumérique)
  nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, '')
  if (/^[A-Z0-9]{5,9}$/.test(nid)) {
    return { nid, note: `CRO IE utilisé: ${nid}` }
  }
  return { nid: '', note: 'Identifiant IE invalide' }
}

if (cc === 'FI') {
  // Finlande (Y-tunnus format 1234567-8 8 chiffres sans tiret)
  const digits = nid.replace(/\D/g, '')
  if (/^\d{8}$/.test(digits)) {
    return { nid: digits, note: `Y-tunnus FI utilisé: ${digits}` }
  }
  return { nid: '', note: 'Identifiant FI invalide - Y-tunnus attendu (8 chiffres)' }
}

if (cc === 'SE') {
  // Suède (organisationsnummer format 556123-4567 10 chiffres)
  const digits = nid.replace(/\D/g, '')
  if (/^\d{10}$/.test(digits)) {
    return { nid: digits, note: `Org.nr SE utilisé: ${digits}` }
  }
  return { nid: '', note: 'Identifiant SE invalide - Organisationsnummer attendu (10 chiffres)' }
}

if (cc === 'DK') {
  // Danemark (CVR format 12345678 8 chiffres)
  const digits = nid.replace(/\D/g, '')
  if (/^\d{8}$/.test(digits)) {
    return { nid: digits, note: `CVR DK utilisé: ${digits}` }
  }
  return { nid: '', note: 'Identifiant DK invalide - CVR attendu (8 chiffres)' }
}

if (cc === 'NO') {
  // Norvège (organisasjonsnummer 9 chiffres)
  const digits = nid.replace(/\D/g, '')
  if (/^\d{9}$/.test(digits)) {
    return { nid: digits, note: `Org.nr NO utilisé: ${digits}` }
  }
  return { nid: '', note: 'Identifiant NO invalide - Organisasjonsnummer attendu (9 chiffres)' }
}

if (cc === 'CZ') {
  // Tchéquie (ICO 8 chiffres)
  const digits = nid.replace(/\D/g, '')
  if (/^\d{8}$/.test(digits)) {
    return { nid: digits, note: `ICO CZ utilisé: ${digits}` }
  }
  return { nid: '', note: 'Identifiant CZ invalide - ICO attendu (8 chiffres)' }
}

if (cc === 'SK') {
  // Slovaquie (ICO 8 chiffres, même format que CZ)
  const digits = nid.replace(/\D/g, '')
  if (/^\d{8}$/.test(digits)) {
    return { nid: digits, note: `ICO SK utilisé: ${digits}` }
  }
  return { nid: '', note: 'Identifiant SK invalide - ICO attendu (8 chiffres)' }
}

if (cc === 'HU') {
  // Hongrie (cégjegyzékszam format 01-09-123456 8 chiffres)
  const digits = nid.replace(/\D/g, '')
  if (/^\d{8,10}$/.test(digits)) {
    return { nid: digits, note: `Cégjegyzék HU utilisé: ${digits}` }
  }
  return { nid: '', note: 'Identifiant HU invalide' }
}

if (cc === 'SI') {
  // Slovénie (matična številka 10 chiffres)
  const digits = nid.replace(/\D/g, '')
  if (/^\d{10}$/.test(digits)) {
    return { nid: digits, note: `Matična SI utilisé: ${digits}` }
  }
  return { nid: '', note: 'Identifiant SI invalide - Matična številka attendu (10 chiffres)' }
}

  // Fallback générique pour les autres pays
  nid = nid.toUpperCase().replace(/[\s\-./]/g, '')
  if (/[^A-Z0-9]/.test(nid)) return { nid: '', note: 'Identifiant national non alphanumérique' }
  return { nid, note: 'Identifiant générique utilisé' }
},

    lettersToDigits (s) {
      let out = ''
      for (let i = 0; i < s.length; i++) {
        const code = s.charCodeAt(i)
        if (code >= 48 && code <= 57) out += s[i]
        else if (code >= 65 && code <= 90) out += (code - 55)
      }
      return out
    },

    mod97 (numStr) {
      let rem = 0
      for (let i = 0; i < numStr.length; i += 7) {
        const part = String(rem) + numStr.substr(i, 7)
        rem = parseInt(part, 10) % 97
      }
      return rem
    },

    computeICSFromISO2 (cc, nationalIdRaw, businessCode = 'ZZZ') {
      const iso2 = (cc || '').trim().toUpperCase()
      if (!/^[A-Z]{2}$/.test(iso2)) return ''

      const { nid } = this.normalizeNationalId(iso2, nationalIdRaw)
      if (!nid) return ''

      const nidDigits = String(nid).replace(/\D/g, '')
      const nidPadded15 = nidDigits.padStart(15, '0')

      const b = (businessCode || 'ZZZ').toUpperCase()
      if (!/^[A-Z0-9]{3}$/.test(b)) return ''

      const rearr = `${b}${nidPadded15}${iso2}00`
      const numeric = this.lettersToDigits(rearr)
      const remainder = this.mod97(numeric)
      const check = String(98 - remainder).padStart(2, '0')

      return `${iso2}${check}${b}${nidPadded15}`

      
    },
    atStart (val = 1) {
      let that = this
      that.pageCounter = 0
      that.activateSpinner = true
      that.CompaniesList = []
      let filterConditions = that.$engine.company.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.company.getCompany(
        val,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data) {
          resp.data.company.idCompany = val
          resp.data.company.identifier = resp.data.company.account.identifier
          resp.data.company.name = resp.data.company.account.name
          resp.data.company.email_reference = resp.data.company.account.email_reference
          resp.data.company.active = resp.data.company.account.active
          resp.data.company.address = resp.data.company.account.address
          resp.data.company.city = resp.data.company.account.city
          resp.data.company.zip_code = resp.data.company.account.zip_code
          resp.data.company.country = resp.data.company.account.country
          resp.data.company.rights.forEach((item, index) => {
            that.rights.push({right: item, delete: item})
          })
          resp.data.company.profiles.forEach(item => {
            item.id_rights_profile = item.id_rights_profile
            item.libelle = item.libelle
            item.delete = item.id_rights_profile
            item.edit = item.id_rights_profile
          })
          resp.data.company.users.forEach(item => {
            item.id_user_account = item.id_user_account
            item.login = item.login
            item.delete = item.id_user_account
            item.edit = item.id_user_account
          })
          requests = resp.data.company
          that.CompaniesList.push(requests)
          this.updateModel()
          that.$f7.pullToRefreshDone()
          that.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    updateModel () {
      this.identifier = this.CompaniesList[0].identifier
      this.active = this.CompaniesList[0].active
      this.name = this.CompaniesList[0].name
      this.email_reference = this.CompaniesList[0].email_reference
      this.address = this.CompaniesList[0].address
      this.city = this.CompaniesList[0].city
      this.zip_code = this.CompaniesList[0].zip_code
      this.country = this.CompaniesList[0].country
      this.cdtr_scheme_id = this.CompaniesList[0].cdtr_scheme_id || ''
    },
    activateUserDetail (id) {
      let that = this
      if(this.canUserConsult) {
        loadPage(that, {url: '/detailusercompany/' + id + '/' + this.idCompany})
      } else {
        return
      }
    },
    activateUserEdit ($e, id) {
      let that = this
      $e.stopPropagation()
      this.$engine.company.profiles = that.CompaniesList[0].profiles
      loadPage(that, {url: '/editusercompany/' + id + '/' + this.idCompany})
    },
    activateUserDelete ($e, ressource) {
      let that = this
      $e.stopPropagation()
      this.$f7.modal({
        title: this.$i18n.t('administration.del_user_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.usercompany.deleteUser(ressource)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_user'))
                that.atStart(Number(that.CompaniesList[0].idCompany))
              }).catch(e => {
                errorMessageAlert(e, that)
                that.$f7.modal({
                  title: that.$i18n.t('administration.del_error'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    activateProfilDetail (id) {
      let that = this
      if(this.canProfileConsult) {
        loadPage(that, {url: '/detailprofilcompany/' + id + '/' + this.idCompany})
      } else {
        return
      }
    },
    activateProfilDelete ($e, ressource) {
      let that = this
      $e.stopPropagation()
      this.$f7.modal({
        title: this.$i18n.t('administration.del_profile_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.profilcompany.deleteProfil(ressource)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_profile'))
                loadPage(that, {url: '/company/' + that.redirection})
              }).catch(e => {
                if (e.response.data.error === 'id_rights_profile used by a user') {
                  that.$f7.modal({
                    title: that.$i18n.t('administration.unable_del'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                } else {
                  that.$f7.modal({
                    title: that.$i18n.t('administration.del_error'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    activateProfilEdit ($e, id) {
      let that = this
      $e.stopPropagation()
      this.$engine.company.rightsL = that.CompaniesList[0].rights
      loadPage(that, {url: '/editprofilcompany/' + id + '/' + this.idCompany})
    },
    addProfil () {
      let that = this
      this.$engine.company.rightsL = that.CompaniesList[0].rights
      loadPage(that, {url: '/addprofilcompany/' + this.idCompany})
    },
    addUser () {
      let that = this
      this.$engine.company.profiles = that.CompaniesList[0].profiles
      loadPage(that, {url: '/addusercompany/' + this.idCompany})
    },
    addRight () {
      let that = this
      this.$engine.company.rightsL = that.CompaniesList[0].rights
      loadPage(that, {url: '/addrights/' + this.idCompany})
    },
    deleteRight ($e, right) {
      let that = this
      $e.stopPropagation()
      // let rights = (this.CompaniesList[0].rights).filter(r => r !== right)
      // console.log('rights', rights)
      this.CompaniesList[0].account.id = this.idCompany
      this.$f7.modal({
        title: this.$i18n.t('administration.del_right_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$f7.showPreloader(that.$t('administration.right_deleting'))
              that.$engine.company.deleteRight(that.idCompany, that.CompaniesList[0].account, that.CompaniesList[0].rights, right)
              .then(resp => {
                if(resp.status === 200)  {
                  that.$f7.hidePreloader()
                  that.$f7.alert('', that.$t('administration.del_right'))
                  loadPage(that, {url: '/company/' + that.redirection})
                }
                //that.refreshProfileList()
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    changeCompany () {
      let that = this
      if (!this.identifier) {
        this.$f7.alert(this.$i18n.t('company.missing_company_identifier'), 'Error')
        return
      } else if (!this.name) {
        this.$f7.alert(this.$i18n.t('company.missing_company_name'), 'Error')
        return
      } else if (!this.address) {
        this.$f7.alert(this.$i18n.t('company.missing_company_address'), 'Error')
        return
      } else if (!this.city) {
        this.$f7.alert(this.$i18n.t('company.missing_company_city'), 'Error')
        return
      } else if (!this.zip_code) {
        this.$f7.alert(this.$i18n.t('company.missing_company_zip_code'), 'Error')
        return
      } else if (!this.country) {
        this.$f7.alert(this.$i18n.t('company.missing_company_country'), 'Error')
        return
      }
      that.$f7.showPreloader(that.$t('administration.company_edition'))
      this.cdtr_scheme_id = this.computeICSFromISO2(this.country, this.identifier, 'ZZZ')
      this.$engine.company.editCompany(
        this.idCompany,
        this.identifier,
        this.name,
        this.email_reference ? this.email_reference : '##NULL##',
        this.active,
        this.address,
        this.city,
        this.zip_code,
        this.country,
        this.CompaniesList[0].rights,
        this.cdtr_scheme_id
      ).then(resp => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_company'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/company/' + that.redirection})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    },
    seeProfileDetails (items) {
      this.activateProfilDetail(items[0].id_rights_profile)
      this.resetProfileTable = !this.resetProfileTable
    },
    seeUserDetails (items) {
      this.activateUserDetail(items[0].id_user_account)
    },
  }
}
</script>
